// App.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
//import logo from './login_ppms.png';
import './App.css';
import Router from './routes/Router';
//import Theme from './styles/Theme';
//import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { AuthContext } from './contexts/CommonCtx';

function App() {
    const [ ppms, setPpms ] = useState('https://ppms.mingspm.com');
    const [ port, setPort ] = useState('9000');
    const [ mode, setMode ] = useState('');
    const [ ip, setIp ] = useState('');
    const [ user, setUser ] = useState('');
    const [ ml, setMl ] = useState('');
    const [ camera, setCamera ] = useState(0);

    const getIp = async() => {
        try {
            //const res = await axios.get('https://geolocation-db.com/json/');
            //console.log('ip', res.data, res.data.IPv4);
            //const addr = res.data.IPv4;

            const resp = await axios.get(`${ppms}:${port}/appms/port`, { withCredentials: true });
            //console.log('port', resp.data);
            if (resp.data) setPort(resp.data);
            //setPort('8006');

            const res = await axios.get(`${ppms}:${port}/appms/ip`, { withCredentials: true });
            //console.log('ip', res.data);
            const addr = res.data;
            setIp(addr);

            return addr;
        } catch(err) {
            console.log(err);
        };
    };

    const checkAuth = async(addr) => {
        //console.log('addr', addr);

        try {
            //const data = { ip: addr };
            const data = new URLSearchParams({
                ip: addr
            });
            //const res = await axios.post(`${ppms}:${port}/appms/auth`, data, { 'Content-Type': 'application/json', withCredentials: true });
            const res = await axios.post(`${ppms}:${port}/appms/auth`, data, { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', withCredentials: true });
            //console.log('auth_res', res);

            // set user info
            setUser(res.data);

            if (res.data.lang) {
                const r = await axios.get(`${ppms}:${port}/appms/ml/${res.data.lang}`, { withCredentials: true });
                //console.log('ml_res', r);
                // set language
                setMl(r.data);
            }
            //setMode('login');
            setMode('MainMenu');

        } catch(err) {
            setMode('login');
            //console.log(err);
        }
    };

    const reloadChange = () => {
        let refreshing = false;

        // detect controller change and refresh the page
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (!refreshing) {
                    window.location.reload();
                    refreshing = true;
                };
            });
        };
    };

    const updateFound = async() => {
        if ('serviceWorker' in navigator) {

            const registration = await navigator.serviceWorker.getRegistration();
            // (it is also returned from navigator.serviceWorker.register() function)

            if (registration) { // if there is a SW active
                if (registration.waiting) {
                    registration.waiting.postMessage('SKIP_WAITING')
                }
                registration.addEventListener('updatefound', () => {
                    //console.log('Service Worker update detected!');
                    if (registration.installing) {
                        // wait until the new Service worker is actually installed (ready to take over)
                        registration.installing.addEventListener('statechange', () => {
                            if (registration.waiting) {
                                // if there's an existing controller (previous Service Worker), show the prompt
                                if (navigator.serviceWorker.controller) {
                                    // let waiting Service Worker know it should became active
                                    registration.waiting.postMessage('SKIP_WAITING')
                                } else {
                                    // otherwise it's the first install, nothing to do
                                    //console.log('Service Worker initialized for the first time')
                                };
                            };
                        });
                    };
                    //registration.waiting.postMessage('SKIP_WAITING');
                    ////navigator.serviceWorker.controller.postMessage({ message: 'to service worker!', });
                });
            };
        };
    };

    //navigator.serviceWorker.getRegistrations().then(regs =>
    //    regs.forEach(reg => {
    //        reg?.waiting?.postMessage({ type: 'SKIP_WAITING' });
    //    })
    //);

    useEffect(() => {
        (async() => {
            //if (!mode) {
                updateFound();
                reloadChange();

                const addr = await getIp();
                await checkAuth(addr);
            //};
        })();

        //return () => { console.log('cleanup'); };
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //useEffect(() => {
        //console.log('mode', mode);
    //}, [ mode ]);

    //useEffect(() => {
        //console.log('user', user);
    //}, [ user ]);

    return (
        <AuthContext.Provider value={{ ppms, setPpms, port, setPort, ip, setIp, user, setUser, mode, setMode, ml, setMl, camera, setCamera }}>
        {/* <ThemeProvider theme={Theme}> */}
            <CssBaseline />
            <div className="App" onContextMenu={(e) => { e.preventDefault(); }}>
                { mode && <Router /> }
            </div>
        {/* </ThemeProvider> */}
        </AuthContext.Provider>
    );
};

export default App;


